"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var TabsTheme = function TabsTheme() {
  return {
    defaultProps: {
      indicatorColor: 'primary',
      textColor: 'primary'
    },
    styleOverrides: {
      root: {
        borderBottom: "1px solid #ececef",
        minHeight: 'auto'
      }
    }
  };
};

var _default = TabsTheme;
exports["default"] = _default;